export const DEFAULT_MAX_BUDGET = 3_000_000; // 월세 최대값
export const DEFAULT_MAX_DEPOSIT = 20_000_000; // 보증금 최대값
